export const SITE = {
  name: "Power Motores Elétricos",
  tagline: "Energia que move a produção",
  phoneDisplay: "(44) 3029-8292",
  phoneHref: "tel:+554430298292",
  whatsappDisplay: "(44) 92000-8253",
  whatsappNumber: "5544920008253",
  email: "lafaiete@powermotoreseletricos.com.br",
  formUrl: "https://readdy.ai/api/form/da6an0t276v6jjqj8bhg",
};

export function waLink(message?: string): string {
  const base = `https://wa.me/${SITE.whatsappNumber}`;
  if (!message) return base;
  return `${base}?text=${encodeURIComponent(message)}`;
}

export const WA_DEFAULT_MESSAGE =
  "Olá! Gostaria de solicitar um orçamento com a Power Motores Elétricos.";

export const REGIONS = [
  "Paraná",
  "Santa Catarina",
  "Rio Grande do Sul",
  "São Paulo",
  "Rio de Janeiro",
  "Minas Gerais",
  "Espírito Santo",
  "Mato Grosso",
  "Mato Grosso do Sul",
  "Goiás",
  "Distrito Federal",
];

export type TrackEvent =
  | "whatsapp_click"
  | "phone_click"
  | "email_click"
  | "quote_start"
  | "quote_submit"
  | "service_view"
  | "product_view"
  | "map_click";

/**
 * Envia um evento de tracking para dataLayer (GA4/GTM/Ads/Meta) sem IDs inventados.
 * Os IDs de cada ferramenta devem ser configurados pelo cliente posteriormente.
 */
export function track(event: TrackEvent, extra?: Record<string, string>) {
  try {
    if (typeof window === "undefined") return;
    const dataLayer = (window as unknown as { dataLayer?: unknown[] }).dataLayer;
    if (Array.isArray(dataLayer)) {
      dataLayer.push({ event, ...extra });
    }
    if (typeof (window as unknown as { fbq?: (...args: unknown[]) => void }).fbq === "function") {
      (window as unknown as { fbq: (...args: unknown[]) => void }).fbq("trackCustom", event, extra);
    }
  } catch {
    /* tracking não deve quebrar a página */
  }
}